import { ClickToTextRoutes } from './type'

const key = `${ClickToTextRoutes.root}`

export const ClickToTextPath = {
  root: key,
}
